'use strict';

var react = require('react');
var utilities_combineClasses = require('../../_chunks/combineClasses-5P8GTQkg.js');
var theme_index = require('../../_chunks/index-CIVOGJRG.js');
require('../../_chunks/designTokens-CKP-YoT2.js');

require("../../_assets/Center-mvdszplM.css");var styles = {"center":"Center__RdBB29Pv7c__center","centerChildren":"Center__RdBB29Pv7c__centerChildren","centerText":"Center__RdBB29Pv7c__centerText"};

/**
 * The center layout creates a vertical strip of content inside a given container element, with equal spacing on both sides.
 * https://storybook.templafy.com/?path=/docs/layouts-center--centered-article
 */
const Center = react.forwardRef(({ maxWidth = '1200', centerText = false, padding = undefined, centerChildren = false, as = 'div', id, className, style, children, 
// CSSProps
width, minWidth, height, minHeight, maxHeight, overflow, overflowX, overflowY, tabIndex, testId, role, 
// Events
onClick, onScroll, onDoubleClick, onMouseEnter, onMouseLeave, onMouseDown, onMouseUp, onKeyDown, ...rest }, ref) => {
    const paddingStyle = padding
        ? {
            paddingLeft: theme_index.theme.spacing[padding],
            paddingRight: theme_index.theme.spacing[padding],
        }
        : {};
    return react.createElement(as, {
        id,
        ref,
        className: utilities_combineClasses.combineClasses(className, styles.center, centerText ? styles.centerText : '', centerChildren ? styles.centerChildren : ''),
        style: {
            width,
            minWidth,
            height,
            minHeight,
            maxHeight,
            overflow,
            overflowX,
            overflowY,
            ...style,
            maxWidth: theme_index.theme.sizing[maxWidth],
            ...paddingStyle,
        },
        tabIndex,
        role,
        'data-testid': testId,
        onScroll,
        onClick,
        onDoubleClick,
        onMouseEnter,
        onMouseLeave,
        onMouseDown,
        onMouseUp,
        onKeyDown,
        ...rest,
    }, children);
});
Center.displayName = 'Center';

exports.Center = Center;
//# sourceMappingURL=Center.js.map
